import React, { useContext, useMemo } from 'react';
import { ReactComponent as IsolationMode } from '../../../../Assets/Mahindra/Isolation_Mode.svg';
import styles from './index.module.css';
import { formatToINR } from '../../../../Utils/utils';
import { AppContext } from '../../../../App';
import { LoadingOutlined } from '@ant-design/icons';

interface Props {
  onDashboardView: () => void;
  onSpendsView: () => void;
}

const MahindraBankSummary: React.FC<Props> = ({
  onDashboardView,
  onSpendsView,
}) => {
  const { statusData, isAmountVisible, isAccountDetailsFetched, data }: any =
    useContext(AppContext);

  const bankAccountLoading = useMemo(() => {
    const accountDetails = statusData.current.accountDetails.filter(
      (accountDetail: any) =>
        accountDetail.fiType === 'DEPOSIT' &&
        accountDetail.status === 'ACTIVE' &&
        (accountDetail.lastRequestAnalyticsStatus === 'ASYNC_PROCESSING' ||
          accountDetail.lastRequestAnalyticsStatus === 'ASYNC_COMPLETED')
    );

    const accountDetailsOther = statusData.current.accountDetails.filter(
      (accountDetail: any) =>
        (accountDetail.fiType === 'TERM_DEPOSIT' ||
          accountDetail.fiType === 'RECURRING_DEPOSIT') &&
        accountDetail.status === 'ACTIVE' &&
        accountDetail.lastRequestFIStatus === 'DELIVERED'
    );

    if (accountDetails.length > 0 || accountDetailsOther.length > 0) {
      return false;
    } else return true;
  }, [statusData.current.accountDetails]);

  const dataCurrent = data.current;

  const getBankAccountsTitle = useMemo(() => {
    const accountDetails = statusData.current.accountDetails.filter(
      (accountDetail: any) =>
        accountDetail.fiType === 'DEPOSIT' &&
        accountDetail.status !== 'INACTIVE'
    );

    if (accountDetails.length > 0 && dataCurrent?.ASSET?.closingBalance) {
      return dataCurrent.ASSET.closingBalance;
    }

    const rawDataValues = Object.values(dataCurrent?.RAW_DATA || {}).map(
      Number
    );
    const rawDataSum = rawDataValues.reduce(
      (acc, val) => acc + (isNaN(val) ? 0 : val),
      0
    );

    return rawDataSum;
  }, [statusData.current.accountDetails, dataCurrent]);

  const activeAccounts = useMemo(
    () =>
      statusData.current.accountDetails.filter(
        (account: any) => account.status === 'ACTIVE'
      ),
    [statusData.current.accountDetails]
  );

  const uniqueActiveFipIds: string[] = useMemo(() => {
    if (statusData?.current?.accountDetails) {
      const filteredFipIds = statusData.current.accountDetails
        .filter(
          (accountDetail: any) =>
            accountDetail.status === 'ACTIVE' && accountDetail.fipId
        )
        .map((accountDetail: any) => accountDetail.fipId);

      return Array.from(new Set(filteredFipIds));
    }
    return [];
  }, [statusData.current.accountDetails]);

  console.log('Unique Ids:', uniqueActiveFipIds);

  return (
    <div className={styles.bankSummmary_container}>
      <div>
        <IsolationMode className={styles.banksSummary_img} />
      </div>
      <div>
        <h4 className={styles.bankSummary_header}>
          Your bank accounts are synced!
        </h4>
      </div>
      <div className={styles.balance_card}>
        <p className={styles.portfolio}>Your total balance</p>
        <h4>{formatToINR(getBankAccountsTitle, isAmountVisible)}</h4>
        <div className={styles.balance_card_tagline_with_logos}>
          <p className={styles.balance_card_tagline}>
            across {activeAccounts.length} account
            {activeAccounts.length > 1 ? 's' : ''} in
          </p>
          <div className={styles.bank_logo_container}>
            {uniqueActiveFipIds.map((fipId: string, index: number) => (
              <div key={fipId} className={styles.bank_logo_wrapper}>
                <img
                  src={`https://logo.ignosis.ai/${fipId}.jpeg`}
                  alt={fipId}
                  className={styles.bank_logo_bankSummary}
                  style={{ zIndex: uniqueActiveFipIds.length - index }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.button_container_bankSummary}>
        <button
          onClick={onSpendsView}
          className={styles.action_button_banksummary}
        >
          {bankAccountLoading && !isAccountDetailsFetched ? (
            <LoadingOutlined />
          ) : (
            'View Details'
          )}
        </button>
        <button
          onClick={onDashboardView}
          className={styles.action_button_banksummary1}
        >
          FPP Dashboard
        </button>
      </div>
    </div>
  );
};

export default MahindraBankSummary;
